import { touchWebClient } from 'tradera/utils/http';

const antiForgeryHeader = (antiForgeryToken) => {
    return {
        headers: {
            ['X-Xsrf-Token']: antiForgeryToken
        }
    };
};

const validateAsync = async (url, value, antiForgeryToken) => {
    try {
        await touchWebClient.post(
            url,
            {
                value: value.trim()
            },
            antiForgeryHeader(antiForgeryToken)
        );

        return { success: true };
    } catch (err) {
        if (err.response && err.response.data && err.response.status === 400) {
            return { success: false, error: err.response.data };
        }

        throw err;
    }
};

export const validateOrganizationNumber = async (value, antiForgeryToken) => {
    return await validateAsync(
        '/register/api/validate/organization-number',
        value,
        antiForgeryToken
    );
};
export const validateAlias = async (value, antiForgeryToken) => {
    return await validateAsync(
        '/register/api/validate/alias',
        value,
        antiForgeryToken
    );
};
export const validateEmail = async (value, antiForgeryToken) => {
    return await validateAsync(
        '/register/api/validate/email',
        value,
        antiForgeryToken
    );
};
export const getCompanyDetails = async (
    organizationNumber,
    antiForgeryToken
) => {
    return await touchWebClient.get(
        `/api/register/swedish-company/get-details?OrganizationNumber=${organizationNumber}`,
        antiForgeryHeader(antiForgeryToken)
    );
};
export const getMoneyTransferLicenseAgreement = async () => {
    return await touchWebClient.get(
        `api/webapi/member/money-transfer-license-agreement`
    );
};
